// extracted by mini-css-extract-plugin
export default {"container":"FileManager_container__maYpK","title":"FileManager_title__d3TKl"};